import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-126e7bad"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "video-track --me" }

import { computed, onMounted, ref, watch } from 'vue'
import { useBackgroundStore, useDeviceStore } from '@/stores'
import PreviewWrapper from '@/components/checkup/PreviewWrapper.vue'
import { Engine } from '@/types/enums/room.enum'
import BackgroundGallery from '@/components/checkup/BackgroundGallery.vue'
import { covertVideoBgToBackgroundType } from '@/helpers/background.helper'
import useSpaceApi from '@/composables/api/useSpaceApi'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewZoom',
  props: {
  canSetBackground: {
    type: Boolean,
    default: false,
  },
  isAutoState: {
    type: Boolean,
    default: false,
  },
  canOpenSetting: {
    type: Boolean,
    default: false,
  },
  mirrorCanvas: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const device = useDeviceStore()
const backgroundStore = useBackgroundStore()
const { saveLogsChangeBackground } = useSpaceApi()
const localTrackRef = ref<HTMLVideoElement>()
const localTrackCanvasRef = ref<HTMLCanvasElement>()
const isInit = ref<boolean>(false)
const displayVideo = ref<boolean>(false)

const mediaConstrains = computed(() => {
  return {
    haveAudio: device.haveAudio,
    haveVideo: device.haveVideo,
    cameraOn: device.maskCameraOn,
    microphoneOn: device.maskMicrophoneOn,
    maskSelectedVideo: device.maskSelectedVideo,
    maskSelectedAudio: device.maskSelectedAudio,
  }
})

const init = async () => {
  device.setLocalTrackZoom(localTrackRef.value)
  device.setLocalTrackCanvasZoom(localTrackCanvasRef.value)
  await device.startPreviewZoom()
  displayVideo.value = device.maskCameraOn
  isInit.value = true
}
const toggleCamera = async () => {
  if (props.isAutoState) {
    await device.toggleCamera(true)
  } else {
    device.maskCameraOn = !device.maskCameraOn
    if (device.maskCameraOn) {
      await device.startVideoTrackZoom()
    } else {
      await device.stopVideoTrackZoom()
    }
  }
  displayVideo.value = device.maskCameraOn
}

const updateBackground = async () => {
  if (!device.localTrackZoomRef) return
  device.isProcessing = true
  backgroundStore.setStateBackground(backgroundStore.selectedBackground)
  // Log Change Background
  const { backgroundType, imagePath } = covertVideoBgToBackgroundType(
    backgroundStore.currentBackground,
  )
  saveLogsChangeBackground({ engine: Engine.ZOOM, backgroundType, imagePath })
  if (displayVideo.value) {
    await device.localVideoTrack?.stop()
  }
  await device.localVideoTrack?.start(device.localTrackZoomRef)
  await device.setPreviewWithZoomBackground()
  displayVideo.value = device.maskCameraOn
  device.isProcessing = false
}

const toggleMicrophone = async () => {
  if (props.isAutoState) {
    await device.toggleMicrophone(true)
  } else {
    device.maskMicrophoneOn = !device.maskMicrophoneOn
  }
}

watch(
  () => mediaConstrains.value.maskSelectedVideo,
  async () => {
    if (!isInit.value) return
    await device.switchCameraZoom()
  },
)

watch(
  () => mediaConstrains.value.maskSelectedAudio,
  () => {
    if (!isInit.value) return
    device.startAudioTrackZoom()
  },
)

onMounted(async () => {
  init()
})

return (_ctx: any,_cache: any) => {
  const _component_LoadingProcess = _resolveComponent("LoadingProcess")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PreviewWrapper, {
      "is-ready": _unref(device).isReady,
      "is-processing": _unref(device).isProcessing,
      "camera-enabled": _unref(device).maskCameraOn,
      "is-camera-found": _unref(device).haveVideo,
      "allowed-camera": _unref(device).allowedCamera,
      "microphone-enabled": _unref(device).maskMicrophoneOn,
      "is-microphone-found": _unref(device).haveAudio,
      "allowed-microphone": _unref(device).allowedMicrophone,
      "can-set-background": false,
      onToggleCamera: toggleCamera,
      onToggleMicrophone: toggleMicrophone
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_LoadingProcess, {
            loading: _unref(device).isProcessing
          }, null, 8, ["loading"]),
          _withDirectives(_createElementVNode("video", {
            ref_key: "localTrackRef",
            ref: localTrackRef,
            playsinline: ""
          }, null, 512), [
            [_vShow, !_unref(device).isProcessing && displayVideo.value && _unref(device).previewZoomMode === 'video']
          ]),
          _withDirectives(_createElementVNode("canvas", {
            ref_key: "localTrackCanvasRef",
            ref: localTrackCanvasRef,
            width: "1280",
            height: "720",
            class: _normalizeClass(["video-canvas", [__props.mirrorCanvas && 'mirror-canvas']])
          }, null, 2), [
            [_vShow, !_unref(device).isProcessing && displayVideo.value && _unref(device).previewZoomMode === 'canvas']
          ])
        ])
      ]),
      _: 1
    }, 8, ["is-ready", "is-processing", "camera-enabled", "is-camera-found", "allowed-camera", "microphone-enabled", "is-microphone-found", "allowed-microphone"]),
    (__props.canSetBackground && _unref(device).canChangeBackground)
      ? (_openBlock(), _createBlock(BackgroundGallery, {
          key: 0,
          disabled: _unref(device).isProcessing,
          onSelectBackground: updateBackground
        }, null, 8, ["disabled"]))
      : _createCommentVNode("", true)
  ]))
}
}

})